export function courseFilter (courseList, long) {
  return courseList.map(
    ({
      cover,
      expectStartTime,
      expectTime,
      pkid,
      property,
      thumbnail,
      title,
      state,
      signUpFlag,
      enable,
    }) => ({
      cover, // 封面
      expectStartTime, // 预计开始时间
      expectTime, // 预计使用时间
      pkid, // 课程 id
      property, // 课程属性，0-普通课程 1-大图 2-头条推荐（单独接口）
      thumbnail, // 略缩图
      title, // 标题
      state, // 课程状态
      dateString: long
        ? `${dateStringFrom(
          'M 月 D 日，hh:mm',
          expectStartTime
        )} - ${dateStringFrom('hh:mm', expectStartTime + expectTime)}`
        : `${dateStringFrom('hh:mm', expectStartTime)} - ${dateStringFrom(
          'hh:mm',
          expectStartTime + expectTime
        )}`,
      signUpFlag,
      enable,
    })
  )
}

/**
 * 按固定格式格式化时间戳
 *
 * 支持：Y, M, D, W, T, h, m, s
 *
 * @param {ModeString} mode 格式字符串
 * @param {TimeStamp} time 时间戳
 */
export function dateStringFrom (mode, time) {
  if (typeof time !== 'number' || time <= 0) {
    time = Date.now()
  }

  time = new Date(time)

  const Y = time.getFullYear()
  const M = time.getMonth() + 1
  const D = time.getDate()
  const W = time.getDay()
  const h = time.getHours()
  const m = time.getMinutes()
  const s = time.getSeconds()

  mode = mode.replace('YYYY', Y)
  mode = mode.replace('YY', Y % 100)
  mode = mode.replace('MM', M < 10 ? `0${M}` : M)
  mode = mode.replace('M', M)
  mode = mode.replace('DD', D < 10 ? `0${D}` : D)
  mode = mode.replace('D', D)
  mode = mode.replace('W', ['日', '一', '二', '三', '四', '五', '六'][W])
  mode = mode.replace('hh', h < 10 ? `0${h}` : h)
  mode = mode.replace('h', h)
  mode = mode.replace('mm', m < 10 ? `0${m}` : m)
  mode = mode.replace('m', m)
  mode = mode.replace('ss', s < 10 ? `0${s}` : s)
  mode = mode.replace('s', s)
  mode = mode.replace('T', () => {
    if (h >= 3 && h < 6) {
      return '凌晨了'
    } else if (h >= 6 && h < 8) {
      return '早上好'
    } else if (h >= 8 && h < 11) {
      return '上午好'
    } else if (h >= 11 && h < 13) {
      return '中午好'
    } else if (h >= 13 && h < 17) {
      return '下午好'
    } else if (h >= 17 && h < 19) {
      return '傍晚了'
    } else if (h >= 19 && h < 23) {
      return '晚上好'
    } else {
      return '深夜了'
    }
  })

  return mode
}

let handleUrlStringRE = null
let handleUrlStringEL = null

/**
 * 将字符串内的 URL 转化为超链接
 *
 * @param {String} str 需要处理的可能含有 URL 的字符串
 * @return {HTMLString} 返回一个可能含有超链接的 HTML 字符串
 */
export function handleUrlString (str) {
  if (!handleUrlStringRE) {
    const alphaRES = '[A-z]'
    const digitRES = '[0-9]'
    const digitsRES = '[0-9]+'
    const safeRES = '[$-_\\.\\+]'
    const extraRES = '[!\\*‘(),]'
    const hexRES = '[0-9A-Fa-f]'
    const alphadigitRES = '[A-z0-9]'
    const domainlabelRES = `(${alphadigitRES}((${alphadigitRES}|-)*${alphadigitRES})?)`
    // const toplabelRES = `(${alphaRES}((${alphadigitRES}|-)*${alphadigitRES})?)`
    const toplabelRES = '(com|cn|net|org|name|info|cc|tv|co|mobi|top|vip)'
    const hostnameRES = `((${domainlabelRES}\\.)+${toplabelRES})`
    const hostnumberRES = `${digitsRES}\\.${digitsRES}\\.${digitsRES}\\.${digitsRES}`
    const hostRES = `(${hostnameRES}|${hostnumberRES})`
    const portRES = digitsRES
    const hostportRES = `(${hostRES}(:${portRES})?)`
    const unreservedRES = `(${alphaRES}|${digitRES}|${safeRES}|${extraRES})`
    const escapeRES = `(%${hexRES})${hexRES}`
    const ucharRES = `(${unreservedRES}|${escapeRES})`
    const hsegmentRES = `((${ucharRES}|;|:|@|&|=)*)`
    const hpathRES = `(${hsegmentRES}(\\/${hsegmentRES})*)`
    const searchRES = hsegmentRES
    const fragmentRES = hsegmentRES
    const protocolRES = '(https?:\\/\\/)?'
    const urlRES = `${protocolRES}${hostportRES}(\\/${hpathRES}(\\?${searchRES})?(#${fragmentRES})?)?`

    handleUrlStringRE = new RegExp()
    handleUrlStringRE.compile(urlRES, 'g')
    handleUrlStringEL = document.createElement('div')
  }

  if (str && str.replace) {
    handleUrlStringEL.textContent = str
    str = handleUrlStringEL.innerHTML
    return str.replace(handleUrlStringRE, (v, $1) => {
      return `<a href="${$1 ? v : `http://${v}`}" target="blank">${v}</a>`
    })
  } else {
    return ''
  }
}

const extToIcoClassNameMap = {
  'dir': 'ibang-filetype-folder',
  'doc': 'ibang-filetype-doc',
  'docx': 'ibang-filetype-doc',
  'ppt': 'ibang-filetype-ppt',
  'pptx': 'ibang-filetype-ppt',
  'key': 'ibang-filetype-key',
  'pdf': 'ibang-filetype-pdf',
  'jpg': 'ibang-filetype-image',
  'jpeg': 'ibang-filetype-image',
  'gif': 'ibang-filetype-image',
  'png': 'ibang-filetype-image',
  'xls': 'ibang-filetype-excel',
  'xlsx': 'ibang-filetype-excel',
  'zip': 'ibang-filetype-zip',
  'mp3': 'ibang-filetype-music',
  'mp4': 'ibang-filetype-video',
  'numbers': 'ibang-filetype-numbers',
  'pages': 'ibang-filetype-pages',
  '<default>': 'ibang-filetype-default',
}

export function getIcoClassByFileName (fileName) {
  let ext = '<default>'

  if (fileName.includes('.')) {
    const ext2 = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()

    if (Object.keys(extToIcoClassNameMap).includes(ext2)) {
      ext = ext2
    }
  }

  return extToIcoClassNameMap[ext]
}

export function ENUM (...keys) {
  const result = {}
  let i = 1

  if (typeof keys.forEach === 'function') {
    keys.forEach((key) => {
      result[key] = i++
    })
  }

  return result
}

export function throttle (fn, delay, maxDelay) {
  let timer = null
  let startTime = Date.now()

  return function () {
    let that = this
    let args = arguments

    const nowTime = Date.now()

    clearTimeout(timer)

    if (nowTime - startTime >= maxDelay) {
      fn.apply(that, args)
      startTime = Date.now()
    } else {
      timer = setTimeout(() => {
        fn.apply(that, args)
        startTime = Date.now()
      }, delay)
    }
  }
}
